import { render, staticRenderFns } from "./ExamResult.vue?vue&type=template&id=4c5ff210&scoped=true&"
import script from "./ExamResult.vue?vue&type=script&lang=js&"
export * from "./ExamResult.vue?vue&type=script&lang=js&"
import style0 from "./ExamResult.vue?vue&type=style&index=0&id=4c5ff210&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5ff210",
  null
  
)

export default component.exports